// 引入路由和storage工具函数
import {removeItem, clear, getItem, setItem} from "@/utils/auth";
import store from '@/store'
import {Notification} from "element-ui";
import { MessageBox } from "element-ui";
import router from "@/router";
import Cookies from "js-cookie";
import i18n from "@/i18n/i18n";
import { clearSession } from "@/utils/auth";
let lastTime = new Date().getTime()
let currentTime = new Date().getTime()
let timeOut =15 * 60 * 1000 //设置超时时间: 15分钟
let operateInterval = setInterval(checkTimeout, 30000);

window.onload = function () {
  //每次页面整载都重置无操作计时锚点（新会话重新计时15分钟）：
  //避免超时退出→reload→自动登录后，sessionStorage里残留旧lastTime被复用，
  //导致自动登录后立即再次触发超时（死循环）或新会话计时失效
  setItem("lastTime", new Date().getTime());
  checkTimeout();
  window.document.onmousedown = function () {
    setItem("lastTime", new Date().getTime())
  }
};

function checkTimeout() {
  currentTime = new Date().getTime()		//更新当前时间
  lastTime = getItem("lastTime");
  if (currentTime - lastTime > timeOut) { //判断是否超时
    clearSession();
    window.document.onmousedown = null;
    window.clearInterval(operateInterval);
    // 清除storage的数据(登陆信息和token)
    //  clear()
    // 跳到登陆页
    if (router.app._route.path!== "/login" && router.app._route.path!== "/register" && router.app._route.path!== "/resetPwd") {
      //"长时间无操作，退出登录")
      MessageBox.confirm(i18n.t('public.auth.session.timeout'), i18n.t('public.promptBox.prompt'), {
        confirmButtonText: i18n.t('el.messagebox.confirm'),
        showCancelButton: false,
        closeOnClickModal: false,
        customClass: 'messageBox',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/logOut', { type: 2 }).then(() => {
          location.reload();
        })
      }).catch(() => {
        store.dispatch('user/logOut', { type: 2 }).then(() => {
          location.reload();
        })
      });

    }
  }
}

export default function () {
  /* 定时器 间隔30秒检测是否长时间未操作页面 */
  // window.setInterval(checkTimeout, 30000);
}





// WEBPACK FOOTER //
// ./src/utils/astrict.js